import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';
import { useForm } from "react-hook-form";

const AddItem = () => {
    const [user] = useAuthState(auth)

    const { register, handleSubmit } = useForm();
    const onSubmit = (data, event) => {
        console.log(data);
        const url = `https://protected-plateau-21838.herokuapp.com/products/`;
        fetch(url, {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(result => {
                console.log(result);
                event.target.reset()
            })
    };


    return (
        <div className='container w-50 shadow mt-5' >


            <form className='flex flex-column gap-4 border-4 p-3' onSubmit={handleSubmit(onSubmit)}>
                <input className='border-2 pl-2' type="text"  {...register("name")} required placeholder='Product Name' />
                <br /><br />
                <input className='border-2 pl-2' type="text" {...register("supplier")} value={user?.displayName} required placeholder='Supplier' />
                <br /><br />
                <input className='border-2 pl-2' type="email"  {...register("email")} value={user?.email} required placeholder='Email' />
                <br /><br />
                <input className='border-2 pl-2' type="text" {...register("quantity")} placeholder='Quantity' />
                <br /><br />
                <input className='border-2 pl-2' type="text" {...register("price")} placeholder='price' />
                <br /><br />
                <textarea className='border-2 pl-2' {...register("description")} placeholder='Description' />
                <br /><br />
                <input className='border-2 pl-2' type="text" {...register("img")} placeholder='Photo URL' />
                <br /><br />
                <input className='bg-gray-500 text-white px-2 py-1 btn btn-success' type="submit" value='Add New Item' />
            </form>

        </div>
    );
};

export default AddItem;